/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseShellCallExecutingEvent = {
  type: "response.shell_call.executing";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseShellCallExecutingEvent$inboundSchema: z.ZodType<
  ResponseShellCallExecutingEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.shell_call.executing"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseShellCallExecutingEvent$Outbound = {
  type: "response.shell_call.executing";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseShellCallExecutingEvent$outboundSchema: z.ZodType<
  ResponseShellCallExecutingEvent$Outbound,
  z.ZodTypeDef,
  ResponseShellCallExecutingEvent
> = z.object({
  type: z.literal("response.shell_call.executing"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseShellCallExecutingEventToJSON(
  responseShellCallExecutingEvent: ResponseShellCallExecutingEvent,
): string {
  return JSON.stringify(
    ResponseShellCallExecutingEvent$outboundSchema.parse(
      responseShellCallExecutingEvent,
    ),
  );
}
export function responseShellCallExecutingEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseShellCallExecutingEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseShellCallExecutingEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseShellCallExecutingEvent' from JSON`,
  );
}
